import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import localeId from '@angular/common/locales/id';
registerLocaleData(localeId, 'id');
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DATE_PIPE_DEFAULT_OPTIONS, DecimalPipe, registerLocaleData, SlicePipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { JwtModule } from '@auth0/angular-jwt';
import { ShortenPipe, StripTagsPipe, TrimPipe } from 'ngx-pipes';
import { provideToastr, ToastrModule } from 'ngx-toastr';
import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { HttpInterceptor } from './core/helpers/http.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
};

export function CustomPaginator() {
  const customPaginatorIntl = new MatPaginatorIntl();
  customPaginatorIntl.itemsPerPageLabel = 'Item per halaman:';
  customPaginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 dari ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} dari ${length}`;
  };
  customPaginatorIntl.nextPageLabel = '';
  customPaginatorIntl.previousPageLabel = '';

  return customPaginatorIntl;
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'id-ID',
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { timezone: '+0700' },
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([HttpInterceptor, ErrorInterceptor, JwtInterceptor])),
    importProvidersFrom(
      ToastrModule.forRoot({
        positionClass: 'toast-top-right',
        preventDuplicates: true,
      }),
    ),
    importProvidersFrom(JwtModule.forRoot({})),
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    { provide: MatPaginatorIntl, useValue: CustomPaginator() },
    ShortenPipe,
    StripTagsPipe,
    TrimPipe,
    SlicePipe,
    DecimalPipe,
  ],
};
